import React, { useContext, useEffect, useRef } from 'react';
import sounds from '@monorepo/shared/src/transformers/genericSounds';
import useActivityAudio from '@monorepo/shared/src/hooks/use-activity-audio';
import { ActivityContext } from 'state/providers/ActivityProvider';
import FeelingsMatchRound from './components/FMatchRound';
import { formatSounds } from '@monorepo/shared/src/util/sound-format-util';

const FeelingsMatch: React.FC = () => {
  const [{ currentSound }, { loadAudioAssets, stopSound }] = useActivityAudio();
  const [state] = useContext(ActivityContext);
  const soundRef = useRef(currentSound);

  useEffect(() => {
    if (!state?.currentRound?.data) return;
    const { cards, instructions } = state.currentRound.data;
    const { instructions: finalRoundInstructions } =
      state.activity.rounds[state.activity.rounds.length - 1];
    const cardSounds = cards.flatMap((card) => {
      return [card.cardTouch, card.affirmation];
    });
    const fMatchSounds = formatSounds([
      ...cardSounds,
      instructions.introduction,
      instructions.end,
      finalRoundInstructions.introduction,
      finalRoundInstructions.end,
    ]);
    loadAudioAssets([...fMatchSounds, sounds.BOINK]);
  }, [state?.currentRound?.data?.cards]);

  useEffect(() => {
    soundRef.current = currentSound;
  }, [currentSound]);

  useEffect(() => {
    return () => {
      if (soundRef.current) {
        soundRef.current.stop();
        stopSound(); // updates state
      }
    };
  }, []);

  return <>{state?.currentRound?.round && <FeelingsMatchRound />}</>;
};

export default FeelingsMatch;
